import React from "react";
import "./style.css";

export const PrivacyPolicy = ({
                                  setDisplayNav = () => {},
                        }) => {
    return (
        <div className={'privacy-main-content'}>
            <div>Last updated: 22 October 2024</div>
            <h2><strong>Privacy Policy </strong></h2>
            <p>
                We value your ("User," "You," or "Your") privacy and recognize the
                sensitivity of your personal information. We are committed to protecting
                your personal information and using it only as appropriate to provide you
                with the best possible service, products, and opportunities, as described
                in this Privacy Policy.
            </p>
            <p>
                This Privacy Policy explains the online information practices
                <a id="_Hlk515850034"></a>of <a id="OLE_LINK1"></a><a id="OLE_LINK2"></a>Next Vision Limited
                (collectively,
                “Company,” “Next
                Vision,” “we,” “us,” or “our”) which hosts the mobile application Calo
                (collectively, the “Application”).
                <strong>We think it is important </strong>to explain what information We
                collect, what We do with it and to describe the rights you will have with
                respect to your personal data processed by us. Next Vision strictly
                complies with the applicable data protection laws and regulations. Next
                Vision is the data controller for any relevant local legislation.
            </p>
            <p>
                Please note that when using the Application, this Privacy Policy should be
                read in conjunction with our Terms of Use. By accessing the Application,
                you acknowledge that the Privacy Policy and the Terms of Use govern your
                use of the Application.
            </p>
            <p>
                Privacy and personal data protection principles vary from one country to
                another. When you access or visit a third party website or application,
                you are subject to the privacy policy of that website or application.
                Please read the third party’s privacy policy to determine the privacy
                practices that apply to information or data maintained by the website or
                application.
            </p>
            <ol type="I">
                <li><strong>What Information We Collect and How It Is Used</strong></li>
                <p>
                    We may collect and hold personal information related to you that is
                    necessary for the purpose of conducting our business, including (without
                    limitation) to deliver products, services or information, improve our
                    services to offer better experience, and to fulfill our regulatory
                    obligations. We will tell you when we ask for your personal information
                    whether it is a statutory or contractual requirement to give us the
                    information and the consequences of not providing the information.
                </p>
                <p>
                    To undertake above goals, we may collect the following personal
                    information related to our users:
                </p>
                <p>
                    <strong>User profile</strong>: If you are a user of the Application,
                    creating a user profile is optional. If you register for a user account
                    with the Application, we may collect certain information such as your
                    e-mail address, username and password. You can also use your social media
                    login (such as sign in with Apple) to register with us. Note, however,
                    that we do not collect information from your social media account.
                </p>
                <p>
                    <strong>User content:</strong>&nbsp;We will collect any user content you
                    create, share, or post to the Application, which may include information
                    contained in your user account, as well as photos or other image files and
                    associated metadata.
                </p>
                <p>
                    Personal data, including health data (such as weight, exercise habits,
                    nutrition intake), may also be collected from other sources if you choose
                    to connect the app with other third party apps (such as Apple Health,
                    Google Fit). You can control what data are stored and accessed and you can
                    modify the settings at any time. We do not collect information about you
                    from any third party unless we get permission from you. We will process
                    this data to provide you with better dietary and fitness experience. When
                    you choose to have this data imported you are subject to the Apple Health
                    and Google Fit privacy policies and practices.
                </p>
                <p>
                    <strong>Do not provide financial account numbers, social security numbers,
                        pictures of other individuals, information regarding your health status
                        or of other individuals or any other sensitive or confidential
                        information via the Application.</strong>
                </p>
                <p>
                    We may also collect information that you submit when you contact the
                    customer support, or otherwise submit information to the Company,
                    including email address, and other information submitted during your use
                    of the Application.
                </p>
                <p>
                    <strong>Financial Data: </strong>We utilize Apple and Google to process
                    all financial transactions and Next Vision is not provided with any
                    personal data related to your transaction.
                </p>
                <p>
                    <strong>Device and Internet Usage: </strong>If you download the
                    Application, we may collect information from your device, including
                    identifiers to help us identify your device’s hardware and operating
                    system.&nbsp;Device information may be accessed using industry standard
                    identifiers such as those approved by your device operating system
                    manufacturer.
                </p>
                <p>
                    <strong>Cookies: </strong>Cookies are small files which, when placed on
                    your device, enable the Platform to provide certain features and
                    functionality. We and our service providers use cookies to automatically
                    collect information, measure and analyze which pages you click on and how
                    you use the application, enhance your experience using the application,
                    improve our services. Cookies may include information such as your login
                    or registration identification, user preferences, time spent on a website
                    and pages visited. We may also use third-party tracking technology to
                    record similar information regarding you and your activity on the
                    Application. Google Analytics may collect your IP address, data related to
                    the device/browser, or other information about your use of the Application
                    and may do so using cookies. Google Analytics’ data practices are governed
                    by the <a href="https://policies.google.com/privacy">Google Privacy Policy</a>,
                    as it may be amended from time to time. By using the Application, you
                    consent to our use of Cookies.
                </p>
                <p>
                    Additionally, we allow our service providers (including analytics vendors
                    and advertising networks) to collect information about your online
                    activities through cookies. These third parties may use this information
                    to display advertisements on our application and elsewhere online tailored
                    to your interests, preferences, and characteristics. We are not
                    responsible for the privacy practices of these third parties, and the
                    information practices of these third parties are not covered by this
                    Privacy Policy.
                </p>
                <p>
                    Some devices may offer a “Do Not Track” feature, however our Application
                    does not respond to “Do Not Track” signals.
                </p>
                <p>
                    You can change your cookie preferences by clicking on the <a href="foodscanner://dl/cookie-control">cookie
                    management tool</a> implemented on our Application/Website.
                </p>
                <p>
                    Current versions of web browsers also offer user controls regarding the
                    placement and duration of both first and third-party cookies. You can find
                    information about this and find more information about cookies at
                    https://www.allaboutcookies.org. If you are interested in more information
                    about behavioral advertising especially how to opt-out of these cookies,
                    please visit <a href="https://www.aboutads.info/choices">https://www.aboutads.info/choices</a>/. You can also opt
                    out of
                    interest-based ads through your mobile device
                    settings, where available, using Android or iOS.
                </p>
                <li><strong>How Information Is Used</strong></li>
                <table>
                    <tbody>
                    <tr>
                        <td>
                            <h2><strong>Purpose</strong></h2>
                        </td>
                        <td>
                            <h2><strong>Legal Basis</strong></h2>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To provide support and to respond to your requests and enquiries
                            </p>
                        </td>
                        <td>
                            <p>
                                We have a legitimate interest to respond to your requests and
                                inquiries for ongoing business administration
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To personalize your visits to the Application and to assist you
                                while you use the Application
                            </p>
                        </td>
                        <td rowSpan="3">
                            <p>
                                We have a legitimate interest in providing and improving the
                                Application
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>To deliver the Application’s services</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To improve the Application by helping us understand who uses the
                                Application and how it is being used
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To share data with our service providers, such as those that host
                                data for us, including Amazon Web Services
                            </p>
                        </td>
                        <td>
                            <p>
                                We have a legitimate interest in using vendors to provide business
                                services
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>To share data with our affiliates</p>
                        </td>
                        <td>
                            <p>We have a legitimate interest in improving our services</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To market our products and services as well as enable third parties
                                to provide advertisements to you via the Application
                            </p>
                        </td>
                        <td>
                            <p>
                                We have a legitimate interest in promoting our products and services
                                and generating advertising revenue, and give you choices about
                                whether or not to use our advertising supported free application
                                option
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To send emails and push notifications to existing customers/users
                                for own similar goods and services provided that customers/users
                                have been properly informed beforehand and can cancel such
                                messages/notifications at any time.
                            </p>
                        </td>
                        <td>
                            <p>
                                We have a legitimate interest in sending emails and push
                                notifications to existing customers/users for own similar goods and
                                services.
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                To respond to law enforcement organization, or other government
                                officials where we have a legal obligation, including complying with
                                legal demands and complying with production and court orders. We
                                will notify user of the information request or submission as, and
                                if, allowed.
                            </p>
                        </td>
                        <td>
                            <p>
                                We have a legitimate interest in complying with applicable legal or
                                regulatory obligations
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                The day to day running and management of the business including to
                                monitor, maintain and improve the processes, information and data,
                                technology and communications solutions and services we use; protect
                                our legal rights and interests;<em> </em>and share such personal
                                information with third parties that acquire or are interested in
                                acquiring all or part of our assets or shares, or that succeeds us
                                in carrying on our business;
                            </p>
                        </td>
                        <td>
                            <p>
                                We have a legitimate interest to manage our business including to
                                maintain ongoing operations and to improve and strengthen our
                                operations
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    <strong>Your Right to Object - Please note that you have a right to object to
                        processing of your personal information where that processing is carried
                        out for our legitimate interest.
                    </strong>
                </p>
                <li>
                    <strong>Information That Is Not Covered by This Privacy Policy</strong>
                </li>
                <p>
                    We may allow you to communicate with other users of the Application and
                    post information using message boards and other similar features available
                    through the Application. NONE of the information that you provide using
                    these features is protected by this Privacy Policy. You should consult the
                    privacy practices of these third parties before sharing your information
                    with third parties.
                </p>
                <li><strong>Data Retention </strong></li>
                <p>
                    We retain your personal information for as long as it is necessary and
                    relevant for our business. The criteria used to determine the retention
                    periods include: (i) how long the personal information is needed to
                    provide the services and operate the business; (ii) the type of personal
                    information collected; and (iii) whether we are subject to a legal,
                    contractual or similar obligation to retain the personal information
                    (e.g., mandatory data retention laws, government orders to preserve data
                    relevant to an investigation, or data that must be retained for the
                    purposes of litigation or disputes).
                </p>
                <li><strong>Data Rights</strong></li>
                <p>
                    You have the right (subject to certain limitations) to: (i) request access
                    to personal information we hold about you; (ii) the correction of your
                    personal information when incorrect, out of date or incomplete; (iii)
                    request that we delete your personal information; (iv) opt-out of any
                    marketing communications that we may send to you and to object to us using
                    / holding your personal information if we have no legitimate reason to do
                    so; and (iii) the portability of personal information i.e., ask for a copy
                    of your personal information to be provided to you, or a third party, in a
                    digital format. Where we are relying on your consent to handle your
                    personal information, you have the right to withdraw your consent to this
                    use at any time. We do not sell personal information to third parties for
                    their own business/commercial uses.
                </p>
                <p>
                    All such requests should be made using the contact details set out below.
                    Please note that if you request that your personal information be deleted,
                    you may no longer be able to access or use certain parts of the
                    Application. We will respond to your request in writing, or orally if
                    requested, as soon as practicable and in any event not more than within
                    one month after receipt of your request. In exceptional cases, we may
                    extend this period by two months and we will tell you why. We may request
                    proof of identification to verify your request. For more details in
                    relation to your rights, including how to exercise them, please contact us
                    using the contact details below.
                </p>
                <p>
                    You also have the right to lodge a complaint about the handling of your
                    personal information with an EU data protection authority or other
                    relevant regulator.
                </p>
                <p>
                    California residents may request certain information about our disclosure
                    of personal data during the prior calendar year to third parties for their
                    direct marketing purposes. We do not share your personal data with third
                    parties or corporate affiliates for their direct marketing purposes.
                </p>
                <li><strong>Security</strong></li>
                <p>
                    We maintain security standards and procedures designed to prevent
                    unauthorized access to your data by anyone, including our staff. We use
                    commercially reasonable means such as (but not limited to) data
                    encryption, firewalls and server authentication to protect the security of
                    your personal information. The Company and our staff and any third parties
                    hired to provide support services will be required to observe our privacy
                    standards and to allow us to audit them for compliance. However, no
                    information security defenses are impenetrable, and we cannot guarantee
                    the security of our applications, servers or databases, nor can we
                    guarantee that information you supply will not be intercepted while being
                    transmitted to us over the Internet.
                </p>
                <li><strong>International Audience</strong></li>
                <p>
                    The Application is hosted in the United States. Therefore, personal
                    information collected from you, including via the Application, will be
                    transferred to the United States. Such transfer may not provide a similar
                    level of protection to that provided by countries in foreign
                    jurisdictions. As discussed above, we have a legitimate interest in
                    utilizing service providers in the United States to provide you with the
                    services.
                </p>
                <p>
                    Please do not use the Application if you do not agree to the transfer and
                    processing of your personal information in the United States or if it is
                    illegal to do so in your home country.
                </p>
                <li><strong>Children’s Privacy</strong></li>
                <p>
                    We do not knowingly collect personal information from children under the
                    age of 16, and in the event that we learn that a child under the age of 16
                    has provided information on the Application, we will delete that
                    information as soon as possible.
                </p>
                <li><strong>Changes</strong></li>
                <p>
                    This Privacy Policy sets out our current policies and demonstrates our
                    commitment to your privacy. We may change the content or services found on
                    the Application at any time, and consequently our Privacy Policy may
                    change at any time in the future and will be updated from time to time.
                    Whenever we make changes to this Privacy Policy that are important for you
                    to know about, we will post the updated Privacy Policy at this link.
                </p>
                <li><strong>Your Queries</strong></li>
                <p>
                    If you have any queries regarding privacy issues or if you wish to
                    exercise your data rights as described above, email us or visit any of our
                    branches for more information. To ensure that we carry out your
                    instructions accurately, to help us continually improve our service and in
                    the interests of security, we may monitor and/or record your telephone
                    calls with us.
                </p>
                <p>Our contact information:</p>
                <p><strong>Next Vision Limited</strong></p>
                <p>
                    Address: RM D 10/F Tower A Billion CTR 1 Wang Kwong RD Kowloon Bay KL Hong
                    Kong
                </p>
                <p>Contact email: website@caloapp.ai</p>
            </ol>
        </div>
    );
};
